import { render, staticRenderFns } from "./singleCar.vue?vue&type=template&id=cce9a84c&scoped=true&"
import script from "./singleCar.vue?vue&type=script&lang=js&"
export * from "./singleCar.vue?vue&type=script&lang=js&"
import style0 from "./singleCar.vue?vue&type=style&index=0&id=cce9a84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce9a84c",
  null
  
)

export default component.exports